import { createSelector } from '@opengov/compose-app/reselect';

import { effectSelector } from './effectState';

export const selectQueuedEffects = createSelector(
  effectSelector,
  state => state.queued
);
export const selectAll = state => state;
export const selectEffectSubscriberProps = createSelector(
  selectQueuedEffects,
  selectAll,
  (queuedEffects, state) => ({ queuedEffects, state })
);
